import { useMutation } from '@tanstack/react-query';

import { ApiError } from '@/lib/errors';

import { videoCallService } from '../services';

/**
 * Mutation hook for POST /sessions/:id/call/recording/stop. 404
 * responses are treated as success because "no active recording" is
 * semantically equivalent to "already stopped" — this covers the
 * backend race where emptyTimeout or admin action stopped the
 * recording out-of-band. Real 5xx errors still surface as isError.
 */
export function useStopRecording() {
  return useMutation({
    mutationFn: async (sessionId: string) => {
      try {
        await videoCallService.stopRecording(sessionId);
      } catch (err) {
        if (err instanceof ApiError && err.status === 404) {
          return;
        }
        throw err;
      }
    },
  });
}
